<!--  -->
<template>
  <div class="quotation" v-title data-title="保费测算">
    <div class="header">
      <div>
        <img src="@/assets/img/header01.png" alt="" />
        <div class="logo">
          <img src="@/assets/img/logo2.png" alt="" />
        </div>
      </div>
    </div>
    <div class="form">
      <div class="form-item">
        <div class="title">建筑工程一切险</div>
        <div>
          <span>工程造价</span>
          <div class="input">
            <input v-model="price" style="text-align:right" type="number" placeholder="输入金额" />元
          </div>
        </div>
      </div>
      <div class="form-item">
        <div class="title">第三者责任</div>
        <div>
          <span>每人赔偿限额</span>
          <div class="input">
            <!-- <input
              v-model="product1"
              disabled
              type="text"
              placeholder="点击选择"
            />
            <i class="iconfont icon-youjiantou"></i> -->
            <el-radio-group text-color="#323233" v-model="product1">
              <el-radio :label="500000">50万元</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div>
          <span>每次事故及累计赔偿限额</span>
          <div class="input">
            <el-radio-group text-color="#323233" v-model="product2">
              <el-radio :label="2000000">200万元</el-radio>
              <el-radio :label="5000000">500万元</el-radio>
            </el-radio-group>
            <!-- <input
              v-model="product2"
              disabled
              type="text"
              placeholder="点击选择"
            />
            <i class="iconfont icon-youjiantou"></i> -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="!popupVisible" class="container">
      <div class="title title-blue">免赔额（出险后自行承担金额）</div>
      <table cellspacing="0">
        <thead>
          <tr>
            <th>保障范围</th>
            <th>第一部分:财产损失</th>
            <th>第二部分:第三者责任</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>免赔</td>
            <td>每次事故绝对免赔额RMB5,000或损失金额的10%,两者以高者为准</td>
            <td>
              第三者财产损失每次事故绝对免赔额RMB5,000或损失金额的10%;第三者人身伤害无免赔
            </td>
          </tr>
        </tbody>
      </table>
      <div class="title">
        注:总保费=(工程造价金额+累计赔偿限额)*费率<br />
      </div>
      <div class="title">*市场平均费率:0.07%</div>
      <div class="footer-wrap">
        <div class="price">
          <div>
            测算保费金额为<span>{{ insurerprice }}</span
            >元/年
          </div>
        </div>
        <div class="footer">
          <!-- <div @click="tohome" class="btn-item">
            <i class="iconfont icon-youjiantou"></i>
            <p>返回详情</p>
          </div> -->
          <!-- <div @click="submitPrice" class="btn-item">
          <p>保存报价</p>
        </div> -->
          <div @click="topolicyFrom" class="btn-item">
            <img src="@/assets/img/btn.png" alt="">
            <p>立即投保</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-if="popupVisible" class="footer-open">
      <mt-popup
        v-model="popupVisible"
        popup-transition="popup-fade"
        position="bottom"
      >
        <div class="picker-toolbar-title">
          <div class="usi-btn-sure" @click="addrConfirm">确定</div>
        </div>
        <div class="picken-center"></div>
        <mt-picker
          ref="picker"
          :slots="slots"
          value-key="name"
          :itemHeight="50"
          @change="onValuesChange"
        >
        </mt-picker>
      </mt-popup>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      product1: 500000,
      product2: "",
      inputType: "",
      price: "",
      insurerprice: "?",
      list1: [
        {
          id: 0,
          name: "200,000",
        },
        {
          id: 1,
          name: "500,000",
        },
      ],
      list2: [
        {
          id: 0,
          name: "1,00,000",
        },
        {
          id: 1,
          name: "2,000,000",
        },
        {
          id: 3,
          name: "5,000,000",
        },
        {
          id: 4,
          name: "10,000,000",
        },
      ],
      slots: [
        {
          values: [],
        },
      ],
      popupVisible: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    price() {
      // console.log(this.price,this.product2);
      var str = this.product2;
      var num = Number(this.price) + Number(str);
      if (this.price != "" && this.product2 != "" && this.product1 != "") {
        this.insurerprice = ((num * 0.07) / 100).toFixed(0);
      }
      if (this.insurerprice < 1000) {
        this.insurerprice = 1000;
      }
    },
    product1() {
      // console.log(this.price,this.product2);
      var str = this.product2;
      var num = Number(this.price) + Number(str);
      if (this.price != "" && this.product2 != "" && this.product1 != "") {
        this.insurerprice = ((num * 0.07) / 100).toFixed(0);
      }
      if (this.insurerprice < 1000) {
        this.insurerprice = 1000;
      }
    },
    product2() {
      // console.log(this.price,this.product2);
      var str = this.product2;
      var num = Number(this.price) + Number(str);
      if (this.price != "" && this.product2 != "" && this.product1 != "") {
        this.insurerprice = ((num * 0.07) / 100).toFixed(0);
      }
      if (this.insurerprice < 1000) {
        this.insurerprice = 1000;
      }
    },
  },
  //方法集合
  methods: {
    topolicyFrom() {
      if (this.insurerprice != "?" && this.price != "") {
        var data = {
          engineering_cost: this.price,
          single_limit: this.product1,
          total_limit: this.product2,
          premium: this.insurerprice,
        };
        // console.log(data);
        this.$store.commit("insurerprice", data);
        this.$router.push({
          name: "Policyform",
        });
      }
    },
    tohome() {
      this.$router.push({
        name: "Home",
      });
    },
    getpopupVisible(e) {
      this.inputType = e;
      if (e == 1) {
        this.slots[0].values = this.list1;
      } else if (e == 2) {
        this.slots[0].values = this.list2;
      }
      this.popupVisible = true;
    },
    onValuesChange(picker, values) {
      if (this.inputType == 1) {
        this.product1 = values[0].name;
      } else if (this.inputType == 2) {
        this.product2 = values[0].name;
      }
    },
    addrConfirm() {
      // console.log(this.product);
      this.popupVisible = false;
    },
    submitPrice() {
      if (this.insurerprice != "?") {
        this.$store.commit("insurerprice", this.insurerprice);
      }
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  beforeMount() {}, //生命周期 - 挂载之前
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less">
.quotation {
  width: 100%;
  height: 110%;
  background: #f1f1f1;
  position: relative;
  font-size: 1.5rem;
  overflow-x: hidden;
  overflow-y: scroll;
  
  // overflow: scroll;
  .mint-header {
    background: #fff;
    color: #666;
    font-size: 16px;
  }
  .v-modal {
    opacity: 0;
  }
  .mint-popup {
    width: 100%;
  }
  .picker-item {
    text-align: center;

    font-size: 1.6rem;
  }
  .picker-slot {
    height: 30rem !important;
    overflow: hidden;
  }
  .picken-center {
    position: absolute;
    top: calc(50% - 46px);
    width: 100%;
    height: 52px;
    border-top: 2px solid #cecece;
    border-bottom: 2px solid #cecece;
    // background: #fff;
    opacity: 0.6;
  }
  .picker-selected {
    font-size: 2rem;
    font-weight: bolder;
  }
  .picker-toolbar-title {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    background: #f5f5f5;
    padding-right: 3rem;
  }

  .usi-btn-cancel,
  .usi-btn-sure {
    color: #108ee9;
  }
  .header {
    position: relative;
    display: flex;
    color: #fff;
    > div {
      width: 100%;
      height: 10rem;
      .logo {
        position: absolute;
        top: calc(50% - 5rem);
        left: calc(50% - 14.3rem);
        height: 8rem;
        width: 28.6rem;
        // margin-left: 2rem;
        // padding: 2rem;
        font-size: 2rem;
      }
      .title {
        margin-left: 2rem;
        padding: 1rem;
        font-size: 2.8rem;
        letter-spacing: 0.5rem;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .form {
    background: #fff;
    padding: 3rem 2.5rem;
    input {
      width: 11rem;
      background: #fff;
      font-size: 15px;
      color: #000;
      font-weight: bold;
    }
    .form-item {
      padding-bottom: 1rem;
      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.5rem;
        border-bottom: 1px solid #909090;
        .input {
          width: 15rem;
          text-align: right;
          i {
            color: #b7b7b7;
          }
          .el-radio-group {
            .el-radio {
              margin-right: 5px !important;
              .el-radio__label {
                font-weight: bold;
              }
            }
            .el-radio.is-checked {
              .el-radio__label {
                color: #30262a;
              }
              .el-radio__inner {
                width: 16px;
                height: 16px;
                border-color: #dcdfe6;
                background: #dcdfe6;
              }
              .el-radio__inner::after {
                width: 8px;
                height: 8px;
                background: #6d6d6d;
              }
            }
          }
        }
      }
      .title {
        border: 0;
        color: #215fbf;
        font-size: 1.8rem;
        font-weight: bold;
      }
    }
  }

  .footer-open {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 30rem;
    background: #fff;
  }
  .container {
    padding: 1rem 2.5rem;
    .title {
      // width: 26rem;
      padding: 1rem 0;
      // margin: 1rem 0;
    }
    .title-blue{
      color: #215fbf;
      font-weight: bold;
      font-size: 1.7rem;
    }
    table {
      font-size: 12px;
      margin: 1rem 0;

      thead {
        tr {
          th {
            font-weight: normal;
            zoom: 0.8;
            background: #99a7d8;
            padding: 1rem;
            border: 1px solid #bec5de;
            text-align: center;
          }
          th:nth-child(1) {
            width: 5rem;
            border-top-left-radius: 2rem;
          }

          th:nth-child(3) {
            border-top-right-radius: 2rem;
          }
        }
      }
      tbody {
        tr {
          td {
            zoom: 0.8;
            padding: 1rem;
            border: 1px solid #bec5de;
            text-align: center;
          }
          td:nth-child(1) {
            border-bottom-left-radius: 2rem;
          }

          td:nth-child(3) {
            border-bottom-right-radius: 2rem;
          }
        }
      }
    }
    .footer-wrap {
      min-width: 30rem;
      width: 34rem;
      box-sizing: border-box;
      position: relative;
      margin:  0 auto;
      // bottom: 5rem;
      .price {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        span {
          font-size: 4rem;
          font-weight: bolder;
          color: #215fbf;
        }
      }
      .footer {
        display: flex;
        justify-content: space-around;
        .btn-item {
          display: flex;
          width: 38rem;
          height: 5rem;
          justify-content: center;
          align-items: center;
          font-size: 1.6rem;
          // border: 1px solid skyblue;
          color: #fff;
          border-radius: 1rem;
        }
        .btn-item:nth-child(1) {
          position: relative;
          // background: #1556bc;
          img{
            height: 100%;
            width: 100%;
            position: absolute;
            z-index: 1;
          }
          p{
            z-index: 2;
          }
          i{
            z-index: 2;
          }
        }
        .btn-item:nth-child(2) {
          background: #99a7d8;
        }
        .btn-item:nth-child(3) {
          background: #1556bc;
        }
      }
    }
  }
}
</style>
